export interface ApiErrorOptions {
  status: number;
  code: string;
  message: string;
  details?: unknown;
  retryIn?: number | null;
}

export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly details?: unknown;
  readonly retryIn?: number | null;

  constructor({ status, code, message, details, retryIn }: ApiErrorOptions) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
    this.retryIn = retryIn ?? null;
  }
}
